module.exports = __webpack_public_path__ + "static/media/portal-exit.0bd738d2.svg";